const sla_overview = {
	table: {
		dcid: "Datacenter ID",
		debtor_code: "Debtor Code",
		hostname: "Hostname",
		name: "VPS Name",
		node: "Node",
		sla: "SLA Level",
		vmid: "VM ID",
	},
	title: "SLA Overview",
};

export default sla_overview;
